"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.replace");
var _zhjyEditor = _interopRequireDefault(require("@/components/editor/zhjyEditor.vue"));
var _fileUpload = _interopRequireDefault(require("@/components/fileUpload.vue"));
var _competitionColumn = require("@/api/competitionColumn/competitionColumn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Editor: _zhjyEditor.default,
    FileUpload: _fileUpload.default
    // fileUpload
  },
  data: function data() {
    return {
      accept: ".png,.jpg,.pdf",
      contestTypeList: [],
      //所属比赛
      courseLevelList: [],
      // 层次
      yearList: [],
      // 年份
      coTypeList: [],
      //比赛类型
      form: {
        contest: "",
        //所属比赛
        courseLevel: "",
        //层次
        createBy: "",
        // 创建人id
        createTime: "",
        // 创建时间
        enableNewsUrl: 0,
        //是否启用新闻真实url
        id: "",
        imageUrl: "",
        // 封面
        isDelete: 0,
        newsContent: "",
        //新闻内容
        newsSummary: "",
        newsFile: "",
        //新闻附件
        newsTitle: "",
        //新闻标题
        newsUrl: "",
        //	新闻真实url
        provinceId: this.$store.getters.provinceId,
        sort: null,
        //排序
        status: 0,
        //发布状态
        updateBy: "",
        //修改人
        updateTime: "",
        //	更新时间
        viewCount: null,
        // 查看人数
        year: "",
        //年份
        uploadFileList: []
      },
      fileList: [],
      rules: {
        newsTitle: [{
          required: true,
          message: "此项不能为空",
          trigger: "blur"
        }],
        newsUrl: [{
          type: 'url',
          message: '请输入以http://或https://开头的网址',
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  methods: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    // 获取比赛类型
    getwContestType: function getwContestType() {
      var _this = this;
      (0, _competitionColumn.typeListAll)({
        provinceId: this.$store.getters.provinceId
      }).then(function (res) {
        _this.coTypeList = res.data;
      });
    },
    // 获取比赛名称
    getwContestName: function getwContestName() {
      var _this2 = this;
      (0, _competitionColumn.nameListAll)({
        provinceId: this.$store.getters.provinceId
      }).then(function (res) {
        _this2.contestTypeList = res.data;
      });
    },
    isnumber: function isnumber(val) {
      val = val.replace(/[^0-9]/gi, "");
      // 此处还可以限制位数以及大小
      return val;
    },
    getUploadFileData: function getUploadFileData(data) {
      if (data.code == 1) {
        this.form.uploadFileList.push(data);
        this.fileList.push({
          fileName: data.fileName
        });
        this.$message({
          type: "success",
          message: "上传成功"
        });
      }
    },
    del: function del(index) {
      this.$delete(this.fileList, index);
      this.$delete(this.form.uploadFileList, index);
    }
  }, "isnumber", function isnumber(val) {
    val = val.replace(/[^0-9]/gi, "");
    // 此处还可以限制位数以及大小
    return val;
  }), "successUpLoad", function successUpLoad(e) {
    this.form.imageUrl = e.ossOriUrl;
  }), "submit", function submit(v) {
    var _this3 = this;
    this.$refs[v].validate(function (valid) {
      if (valid) {
        (0, _competitionColumn.newsUpload)(_this3.form).then(function (res) {
          if (res.code === 2000) {
            _this3.$message.success("操作成功。");
            _this3.$router.push("/competition/news");
          }
        });
      }
    });
  }), "isBack", function isBack() {
    this.$router.push("/competition/news");
  }),
  created: function created() {
    var _this4 = this;
    // 文章类别
    // this.contestTypeList = this.$store.getters.wCourseLevel
    // 层次
    this.courseLevelList = this.$store.getters.wCourseLevel;
    // 年份
    this.yearList = this.$store.getters.wYearListAll;
    // // 比赛类型
    // this.coTypeList = this.$store.getters.wContestType
    // // 所属比赛
    // this.contestTypeList = this.$store.getters.wContestName
    // console.log("this.contestTypeList",this.contestTypeList)
    this.getwContestType();
    this.getwContestName();
    if (this.$route.query.id) {
      (0, _competitionColumn.getContestNotice)({
        id: this.$route.query.id
      }).then(function (res) {
        _this4.form = res.data;
        for (var i in res.data.uploadFileList) {
          _this4.fileList.push({
            fileName: res.data.uploadFileList[i].fileName
          });
        }
        _this4.$refs.child.initEditor(res.data.newsContent);
      });
    }
  }
};